import { InjectionToken } from "@angular/core";
import { IConnectReceiverModalService } from "./i-connect-receiver-modal.service";

export const connectReceiverModalServiceInjectionToken: InjectionToken<IConnectReceiverModalService> = new InjectionToken<IConnectReceiverModalService>("digital-signage.user-dashboard.dashboard-web.ConnectReceiverModalService");
